import { render, staticRenderFns } from "./InvestmentMixControl.vue?vue&type=template&id=4965ff9a&"
import script from "./InvestmentMixControl.vue?vue&type=script&lang=js&"
export * from "./InvestmentMixControl.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentMixControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports